<template>
    <div class="conteudoTable">
            <p  class="txtDadosG">Dados de Cobrança</p>
            <div v-if="table.fatura != null">
                <p  class="txtDadosG" align="left"> Fatura</p>
                <div class="dadosGerais" style="display:block;">
                    <div style="display:flex;justify-content: space-between;">
                        <div style="width:33%;margin-top:7px"> 
                            <label for="">Número</label><br>
                            <input type="text" v-model="table.fatura.numero" readonly>
                        </div>
                        <div style="width:33%;margin-top:7px"> 
                            <label for="">Valor Original</label><br>
                            <input type="text" v-model="table.fatura.valorOriginal"  readonly>
                        </div>
                        <div style="width:33%;margin-top:7px"> 
                            <label for="">Valor do Desconto</label><br>
                            <input type="text"  v-model="table.fatura.valorDesconto" readonly>
                        </div>
                    </div>
                    <div>
                        <div style="width:33%;margin-top:7px"> 
                            <label for="">Valor Liquido</label><br>
                            <input type="text" v-model="table.fatura.valorLiquido" readonly>
                        </div>
                    </div>
                </div>
            </div>
            <div v-if="table.duplicatas.length >0">
                <p  class="txtDadosG">Duplicatas</p>            
                <div class="dadosGerais" >
                        <div style="width:33%;">
                            <label for="">Número</label><br>
                            <div v-for="(n,i) in table.duplicatas" :key="i"> 
                                <input type="text"  v-model="n.numero" readonly> 
                            </div>
                        </div>
                        <div style="width:33%;">  
                            <label for="">Vencimento</label><br>              
                            <div v-for="(n,i) in table.duplicatas" :key="i"> 
                                <input type="text"  v-model="n.vencimento" readonly> 
                            </div>
                        </div>
                        <div style="width:33%;">
                            <label for="">Valor</label><br>
                            <div v-for="(n,i) in table.duplicatas" :key="i"> 
                                <input type="text"  v-model="n.valor" readonly> 
                            </div>
                        </div>
                        
                </div>
            </div>
        <div v-if="table.formasPagamento.length > 0">        
                <p  class="txtDadosG">Formas de Pagamento</p>
                <div class="dadosGerais" style="display:block;">
                    <div class="gridTT ad">                
                        <div>
                            Ind.
                        </div>                   
                        <div>
                            Forma de Pagamento
                        </div>
                        <div>
                            Meio de Pagamento
                        </div>
                        <div>
                            Valor do Pagamento
                        </div>                     
                    </div >          
                    <div v-for="(n,i) in table.formasPagamento" :key="i" >
                    <div  class="gridTT">                       
                                <div style="display: flex;    justify-content: center;    align-items: center;" >
                                    <div class="maisM" @click="exibir = !exibir">
                                        <span>+</span>
                                    </div>
                                </div>                          
                                <div class="qa">
                                        {{n.detalhamento[0].indicadorPagamento}}
                                </div>
                                <div class="qa">
                                {{n.detalhamento[0].meioPagamento}}
                                </div>
                                <div class="qa">
                                    {{n.detalhamento[0].valor}}
                                </div>                            
                    </div>   
                    <div :class="{exiNot:true,exibir:exibir}" style="border: 1px solid #707070;margin-bottom: 20px;border-radius: 5px;padding: 15px;">
                         <div class="dadosGerais" >
                        <div style="width:33%;">
                            <label for="">Troco</label><br>                            
                                <input type="text"   v-model="n.valorTroco" readonly> 
                          
                        </div>
                         </div>
                    </div>  
                    </div>              
                </div>
        </div>
    </div>
</template>

<script>

export default {
props:['table'],
    data(){
        return{
            exibir:false,
        }
    },
    methods:{
       
    },
    mounted(){
        console.log(this.table)
       
    }
}
</script>

<style>
.exiNot{
    display: none;
}
.exibir{
    display: block;
}
.maisM{
   background: #fff; padding: 2px;display: flex;border: 2px solid #06938a;height:21px; justify-content: center;align-items: center;font-weight: bold;border-radius: 0px;cursor: pointer;
}
.maisM span{
    font-weight: bold;
}
.ad{
    
    font-weight: 600;
    color:#009188;
}
div.dadosGerais table{
    width: 100%;
} 
div.dadosGerais table  .p{
    border-bottom: 2px solid #06938A;
}
div.dadosGerais table .p td{
    color:#009188;
    font-weight: 600;
}
div.dadosGerais table  td{
    font-weight: 600;
}
.qa{
    padding: 7px 5px;
    border-radius: 5px;
    border: 2px solid #06938a;
        font-size: 14px;
    background: #fff;
    margin:1px;
}
.gridTT{
    display: grid;
    grid-template-rows: 1fr;
    grid-template-columns: 30px 1fr 1fr 1fr ;
    font-size: 15px;
}
</style>